/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checking_RecordsInputs */

const en_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking records...`)
};

const es_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisando registros...`)
};

const fr_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification des enregistrements...`)
};

const de_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensätze werden geprüft...`)
};

const ja_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録を確認中...`)
};

const zh_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查记录中...`)
};

const ar_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري فحص السجلات...`)
};

const id_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memeriksa data...`)
};

const it_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo dei record in corso...`)
};

const ru_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка записей...`)
};

const pt_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando registros...`)
};

const ko_checking_records = /** @type {(inputs: Checking_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기록 확인 중...`)
};

/**
* | output |
* | --- |
* | "Checking records..." |
*
* @param {Checking_RecordsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checking_records = /** @type {((inputs?: Checking_RecordsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checking_RecordsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checking_records(inputs)
	if (locale === "es") return es_checking_records(inputs)
	if (locale === "fr") return fr_checking_records(inputs)
	if (locale === "de") return de_checking_records(inputs)
	if (locale === "ja") return ja_checking_records(inputs)
	if (locale === "zh") return zh_checking_records(inputs)
	if (locale === "ar") return ar_checking_records(inputs)
	if (locale === "id") return id_checking_records(inputs)
	if (locale === "it") return it_checking_records(inputs)
	if (locale === "ru") return ru_checking_records(inputs)
	if (locale === "pt") return pt_checking_records(inputs)
	return ko_checking_records(inputs)
});